import { isPosgradoMateria } from "./adaptPosgradoMalla";

export function formatMallaCourseStats(materia) {
  if (isPosgradoMateria(materia)) {
    return `${materia.HBCA} HBCA · ${materia.HTI} HTI · ${materia.Creditos} cr`;
  }
  return `${materia.Horas} h · ${materia.Creditos} cr`;
}
